import { RestServiceUtils } from '../utils/RestServiceUtils';

const activityLogService = {
    getAllKPILogs: (organizationId, placeId, params) => {
        const URL = `/ums/${organizationId}/${placeId}/kpi/loginHistory`;
        return RestServiceUtils.HTTP_GET(URL, params);
    },

    getCircleToSearchLogs: (organizationId, placeId, params) => {
        const URL = `/ums/${organizationId}/${placeId}/kpi/c2s`;
        return RestServiceUtils.HTTP_GET(URL, params);
    },

    getLiveTranscriptLogs: (organizationId, placeId, params) => {
        const URL = `/ums/${organizationId}/${placeId}/kpi/transcript`;
        return RestServiceUtils.HTTP_GET(URL, params);
    },

    getAISummaryLogs: (organizationId, placeId, params) => {
        const URL = `/ums/${organizationId}/${placeId}/kpi/summary`;
        return RestServiceUtils.HTTP_GET(URL, params);
    },

    exportUserSession: (organizationId, placeId, params) => {
        const URL = `/ums/${organizationId}/${placeId}/kpi/loginHistory/export`;
        return RestServiceUtils.HTTP_GET(URL, params);
    },

    exportCircleToSearchLogs: (organizationId, placeId, params) => {
        const URL = `/ums/${organizationId}/${placeId}/kpi/c2s/export`;
        return RestServiceUtils.HTTP_GET(URL, params);
    },

    exportLiveTranscriptLogs: (organizationId, placeId, params) => {
        const URL = `/ums/${organizationId}/${placeId}/kpi/transcript/export`;
        return RestServiceUtils.HTTP_GET(URL, params);
    },

    exportAISummaryLogs: (organizationId, placeId, params) => {
        const URL = `/ums/${organizationId}/${placeId}/kpi/summary/export`;
        return RestServiceUtils.HTTP_GET(URL, params);
    },
};

export default activityLogService;
